import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class HttpActivityService implements HttpInterceptor {
    private activeCount = 0;
    readonly activeRequests$ = new BehaviorSubject<number>(0);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.activeCount++;
        this.activeRequests$.next(this.activeCount);
        return next.handle(req).pipe(
            finalize(() => {
                this.activeCount--;
                this.activeRequests$.next(this.activeCount);
            })
        );
    }
}
